﻿import Swiper from "swiper";
import { clientPreferences } from "../../Shared/ClientPreferences/clientPreferences";

const thumbnailIndexAttribute = "data-thumb-index";

export const slideshow = () => {
  const gallery = document.getElementById("product-page-gallery");
  
  if (!gallery) {
    throw "Unable to find gallery element";
  }
  
  const thumbnailsWrapper = document.getElementById("product-page-thumbnails");

  if (!thumbnailsWrapper) {
    throw "Unable to find thumbnails wrapper element";
  }

  const thumbnailCssClasses = thumbnailsWrapper.getAttribute("data-thumbnail-css-classes");
  const activeThumbnailCssClasses = thumbnailsWrapper.getAttribute("data-active-thumbnail-css-classes");
  
  if (!thumbnailCssClasses || !activeThumbnailCssClasses) {
    throw "Missing thumbnail styles";
  }

  const tryGetIndex = (thumbnail: Element) => {
    const thumbnailIndex = parseInt(thumbnail.getAttribute(thumbnailIndexAttribute) ?? "");

    if (isNaN(thumbnailIndex)) {
      throw `Invalid image index: ${thumbnailIndex}`;
    }
    
    return thumbnailIndex;
  }
  
  const thumbnails = gallery.querySelectorAll(`[${thumbnailIndexAttribute}]`);
  
  const swiper = new Swiper(gallery, {
    grabCursor: true,
    speed: clientPreferences.prefersReducedMotion ? 0 : 300,
    on: {
      activeIndexChange: swiper => {
        // Change thumbnail styles on active index change
        thumbnails.forEach(thumbnail => {
          thumbnail.classList.remove(...activeThumbnailCssClasses.split(" "));
          thumbnail.classList.remove(...thumbnailCssClasses.split(" "));
          
          if (swiper.activeIndex === tryGetIndex(thumbnail))
            {thumbnail.classList.add(...activeThumbnailCssClasses.split(" "));}
          else
            {thumbnail.classList.add(...thumbnailCssClasses.split(" "));}
        })
      }
    }
  });
  
  // Subscribe to thumbnail click events
  thumbnails.forEach(thumbnail => thumbnail.addEventListener("click", () => {
    swiper.slideTo(tryGetIndex(thumbnail));
  }))
}